import React, {useContext} from "react"
import {Button} from "../../components-shared/button/button"
import styles from "./home-page.module.scss"
import {useHistory} from "react-router-dom"
import {Heading, HeadingMedium, HeadingSmall} from "../../components-shared/heading/heading"
import {UserContext} from "../../services/authentication/user-context"
import {InfoEmail} from "../../components-shared/info-email"

export const HomePage: React.FC = () => {
  const history = useHistory()
  const user = useContext(UserContext)

  return <div className={styles.Page}>
    <Heading size="large">Meet en verbeter je klimaatimpact</Heading>

    <div>
      <p>Wat is beter voor het klimaat: vlees vervangen door vis, of toch beter investeren in zonnepanelen? Meer tweedehandskleding of vaker de fiets pakken? Het is soms moeilijk om te zien wat in jouw geval het meeste effect heeft.</p>
      <p>Met GreenUp maken we dat inzichtelijk en verklein je jouw klimaatimpact. Door de persoonlijke suggesties zie je de winst voor het klimaat en wat het je kost.. of oplevert!</p>
      {!user.isAuthenticated() && <Button buttonStyle="primary" onClick={() => { history.push("/signup") }}>Direct starten</Button>}
    </div>

    <div className={styles.ThreeBoxes}>
      <div className={styles.Box}>
        <HeadingSmall>Jouw persoonlijke CO2 score</HeadingSmall>
        <p>Scoor jij onder het Nederlands gemiddelde?</p>
      </div>
      <div className={styles.Box}>
        <HeadingSmall>Snel en simpel</HeadingSmall>
        <p>Jouw uitgaven worden automatisch ingedeeld en omgerekend naar CO2</p>
      </div>
      <div className={styles.Box}>
        <HeadingSmall>Advies op maat</HeadingSmall>
        <p>Welke acties geven in jouw geval de meeste milieuwinst (en kosten het minst)?</p>
      </div>
    </div>

    <div>
      <HeadingMedium>Aan de slag in 4 stappen</HeadingMedium>
      <ol>
        <li>Maak een account aan</li>
        <li>Download je uitgaven bij jouw bank, upload ze bij GreenUp</li>
        <li>Veel uitgaven worden al herkend, sommige moet je nog indelen</li>
        <li>Zie waar jouw impact zit en waar je het beste kunt verbeteren</li>
      </ol>
    </div>

    <div>
      <HeadingMedium>Onze visie</HeadingMedium>
      <p>
        Het klimaat kan onze Nederlandse levensstijl niet aan. De <span className={styles.Emphasis}>politiek</span> streeft de komende 10 jaar naar halvering
        van onze CO2 impact. Veel <span className={styles.Emphasis}>bedrijven</span> zijn zich bewust van de grote opgave en bieden duurzame alternatieven aan.
        Maar in hoeverre weten <span className={styles.Emphasis}>consumenten</span> wat hun rol is? En hoe weten zij of minder consumptie of een duurzaam
        alternatief iets uitmaakt?
      </p>
      <p>
        Wij geloven dat veel mensen wel bij willen dragen aan een duurzamere wereld, maar gedemotiveerd worden van
        de grote adviezen van de groene beweging: geen vlees, niet vliegen, niet autorijden, etc. GreenUp maakt eerst
        <i>per gebruiker</i> inzichtelijk of en waar een grote impact zit en koppelt daar kleinere en grotere verbeterstappen
        aan. Het is dan - voor het eerst - aan de consument om te kiezen hoe ver hij of zij wil gaan in het bijdragen
        aan CO2-vermindering.
      </p>
    </div>

    <div>
      <HeadingMedium>Hoe weet GreenUp mijn klimaatimpact?</HeadingMedium>
      <p>
        GreenUp is gebaseerd op dagelijkse keuzes, namelijk jouw uitgaven. Dit uitgavenpatroon wordt ingedeeld in categorieën en daarna omgerekend naar jouw persoonlijke klimaatimpact. Elke uitgave categorie heeft namelijk een eigen omrekenfactor om van euro’s naar kilogrammen CO2-equivalenten te rekenen. We maken hierbij gebruik van data van het PlanBureau voor de Leefomgeving (PBL), de ‘groene rekenkamer’ van de overheid. GreenUp weet dus niet op productniveau de CO2 impact, maar werkt met gemiddelden zoals die doorgerekend zijn voor heel Nederland. Omdat GreenUp al je uitgaven ziet, geeft dit dus een heel volledig beeld.
      </p>
    </div>

    <div>
      <HeadingMedium>Over ons</HeadingMedium>
      <p>
        GreenUp is een initiatief van <a href="https://www.linkedin.com/in/marijnbos/">Marijn Bos</a> en <a href="https://www.linkedin.com/in/rubenverhaaf/">Ruben Verhaaf</a>.
      </p>
    </div>

    <div>
      <HeadingMedium>Contact</HeadingMedium>
      <p>
        Je kunt ons bereiken op <InfoEmail/>.
      </p>
    </div>

    <div>
      <HeadingMedium>GreenUp is in ontwikkeling</HeadingMedium>
      <p>
        Onder de motorkap verbeteren we regelmatig de methode zodat de CO2-algoritmen steeds slimmer en nauwkeuriger worden. En in de tool zul je de komende tijd nieuwe gepersonaliseerde adviezen en andere inspirerende opties zien verschijnen.
      </p>
    </div>

    <div>
      <HeadingMedium>Privacy</HeadingMedium>
      <p>Wat doen jullie met de financiele data die gebruikers uploaden?</p>
      <ul>
        <li>We gebruiken jouw gegevens om jou een zo persoonlijk mogelijk advies te kunnen geven. </li>
        <li>We beloven dat we jouw financiele data nooit zullen verkopen aan andere partijen.  </li>
        <li>GreenUp werkt niet met advertenties en zeker niet op basis van jouw financiele data.</li>
      </ul>

      <p>Is GreenUp wel veilig en volgens de regels?</p>
      <ul>
        <li>Ja, we behandelen jouw data volgens hoge veiligheidsstandaarden. Jouw gegevens staan op Nederlandse servers en we voldoen aan alle AVG eisen. </li>
      </ul>
      Lees hierover meer in ons databeleid.
    </div>
  </div>
}